import { ConfigProvider as PlotsConfigProvider } from '@ant-design/plots';
import { QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider as AntdConfigProvider } from 'antd';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppStateProvider } from '@/common/hooks/AppStateProvider';
import themeConfig, { antdComponentConfig } from '@/common/theme/theme-config';
import createAppQueryClient from '@/common/utils/query-client';
import AppRouter from '@/router';
import './global.css';

const queryClient = createAppQueryClient();

const App = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AppStateProvider>
            <AntdConfigProvider {...antdComponentConfig} theme={themeConfig}>
              <PlotsConfigProvider common={{ theme: 'classic' }}>
                <AntdApp component="main">
                  <AppRouter />
                </AntdApp>
              </PlotsConfigProvider>
            </AntdConfigProvider>
          </AppStateProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};
export default App;
